module.exports = __webpack_public_path__ + "img/vpc19.a8a04c5.png";